module.exports = __webpack_public_path__ + "static/TwoRoofersVert_1920-a5a45a18863628a607b1fee609d14f32.jpg";